import React, { Component } from 'react';

// Elements
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import SectionHeading from '../SectionHeading/SectionHeading';

const BIO_CLAMP_LENGTH = 220;

const SOCIALS = [
    { key: "facebook", icon: "fa-facebook-f", label: "Facebook" },
    { key: "instagram", icon: "fa-instagram", label: "Instagram" },
    { key: "linkedin", icon: "fa-linkedin-in", label: "LinkedIn" },
];

export default class Team extends Component {

    constructor(props) {
        super(props);
        this.state = { expanded: {} };
    }

    toggleBio(index) {
        this.setState(state => ({ expanded: { ...state.expanded, [index]: !state.expanded[index] } }));
    }

    render() {
        if(this.props.team.length === 0) {
            return <></>;
        }
        return (
            <div className="space-medium team-modern">
                <Container>
                    <Row>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <SectionHeading title="Our Team"/>
                        </div>
                    </Row>
                    <div className={"team-grid" + (this.props.team.length === 1 ? " team-grid--single" : "")}>
                        {this.props.team.map((member, index) => {
                            const social_media = member.social_media || {};
                            const socials = SOCIALS.filter(social => social.key in social_media);
                            const bio = member.about || "";
                            const is_long = bio.length > BIO_CLAMP_LENGTH;
                            const expanded = !!this.state.expanded[index];
                            return (
                            <article className="team-card wow fadeInUp" data-wow-delay={`${0.1 * (index + 1)}s`} key={member.name}>
                                <img src={member.avatar} alt={member.name} className="team-card__avatar"/>
                                <div className="team-card__head">
                                    <h3 className="team-card__name">{member.name}</h3>
                                    {member.subhead ? <span className="team-card__credentials">{member.subhead}</span> : null}
                                </div>
                                {bio ?
                                <div className="team-card__body">
                                    <p className={"team-card__bio" + (is_long && !expanded ? " is-clamped" : "")}>{bio}</p>
                                    {is_long ?
                                    <button type="button" className="team-card__toggle" aria-expanded={expanded} onClick={() => this.toggleBio(index)}>
                                        {expanded ? "Show less" : "Read more"} <i className="fa-solid fa-chevron-down"></i>
                                    </button> : null}
                                </div> : null}
                                {socials.length > 0 ?
                                <div className="team-card__social">
                                    {socials.map(social => (
                                        <a key={social.key} href={social_media[social.key]} target="_blank" rel="noopener noreferrer" aria-label={`${member.name} on ${social.label}`}>
                                            <i className={`fa-brands ${social.icon}`}></i>
                                        </a>
                                    ))}
                                </div> : null}
                            </article>
                            );
                        })}
                    </div>
                </Container>
            </div>
        );
    }
}
